import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
    'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-normal transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring',
    {
        variants: {
            variant: {
                default:
                    'hover:bg-primary/80 shadow bg-primary border-transparent text-primary-foreground',
                secondary:
                    'hover:bg-secondary/80 bg-secondary border-transparent text-secondary-foreground',
                destructive:
                    'hover:bg-destructive/80 shadow bg-destructive border-transparent text-destructive-foreground',
                outline: 'text-foreground',
                success:
                    'shadow bg-green-100 border-transparent text-green-800 hover:bg-green-100/80',
                warning:
                    'shadow bg-yellow-100 border-transparent text-yellow-800 hover:bg-yellow-100/80',
                error: 'shadow bg-red-100 border-transparent text-red-800 hover:bg-red-100/80',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
)

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    )
}

export { Badge, badgeVariants }
